import { AnchorScrollTo } from '@studiometa/ui';

/**
 * TableOfContentAnchor class.
 */
export default class TableOfContentAnchor extends AnchorScrollTo {
  /**
   * Config.
   */
  static config = {
    name: 'TableOfContentAnchor',
    emits: ['should-activate'],
    options: {
      activeClass: {
        type: String,
        default: 'is-active',
      },
    },
  };

  isActive = false;

  /**
   * Get the sentinel.
   * @returns {HTMLElement}
   */
  get sentinel() {
    const decodedSelector = decodeURIComponent(this.targetSelector);
    const escapedSelector = CSS.escape(decodedSelector.replace('#', ''));
    return document.querySelector(`#${escapedSelector}`);
  }

  /**
   * Init observer on mount.
   * @returns {void}
   */
  mounted() {
    if (!this.sentinel) {
      return;
    }

    const options = {
      threshold: [0, 0.3],
      rootMargin: '200px 0px 200px 0px',
    };

    this.observer = new IntersectionObserver(([entry]) => {
      const shouldActivate = entry.isIntersecting;
      this.isActive = shouldActivate;
      this.$emit('should-activate', shouldActivate);
    }, options);

    this.observer.observe(this.sentinel);
  }

  /**
   * Mark an element as active or not.
   * @param {boolean} shouldActivate
   * @returns {void}
   */
  toggle(shouldActivate) {
    this.$el.classList.toggle(this.$options.activeClass, shouldActivate);
  }

  /**
   * Destroy observer on destroy.
   * @returns {void}
   */
  destroyed() {
    this.observer.disconnect();
  }
}
